export const GAME_WIDTH = 600;
export const GAME_HEIGHT = 150;
export const FLOOR_Y = 127;
export const DINO_WIDTH = 88;
export const DINO_HEIGHT = 94;

export const DINO_BUNDLE = 'dino-runner';
export const DINO_ATLAS = 'dino-runner';
export const DINO_IMAGE_ASSET = 'dino-runner-image';
export const DINO_META_ASSET = 'dino-runner-meta';
